import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { alunos_geo_bairro } from "../../services/api";

const Alunos_bairros = (props) => {

    const [data2, setData2] = useState([]);
    const [dataR, setDataR] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio']

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const response = await alunos_geo_bairro();
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    console.log("data2", data2);

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    // {
    // 	"sec": "01",
    // 	"bairro_tratado": "BENTO RIBEIRO",
    // 	"alunos": "374"
    // },


    let chartDataBairro = [];
    if (typeof data2 !== 'undefined') {


        chartDataBairro = data2.map((item, index) => {
            const row = [unidades[parseInt(item.sec)]];
            row.push(item.bairro_tratado);
            row.push(parseInt(item.alunos) || 0);
            return row;
        });
    };

    chartDataBairro.sort()
    chartDataBairro.unshift(['Unidade', 'Bairro', 'Alunos']);

    console.log('chartDataBairro', chartDataBairro)

    const options = {
        allowHtml: true,
        pageSize: 15,

    };

    // let formatters = [
    //     {
    //         type: "NumberFormat",
    //         column: 1,
    //         options: {
    //             prefix: "R$",
    //             negativeColor: "red",
    //             negativeParens: true,
    //         },
    //     },
    //     {
    //         type: "NumberFormat",
    //         column: 2,
    //         options: {
    //             prefix: "R$",
    //             negativeColor: "red",
    //             negativeParens: true,
    //         },
    //     },
    //     {
    //         type: "NumberFormat",
    //         column: 3,
    //         options: {
    //             suffix: " %",
    //             negativeColor: "red",
    //             negativeParens: true,
    //         },
    //     },
    //     {
    //         type: "ColorFormat",
    //         column: 3,
    //         ranges: [
    //             [-10000, 0, "white", "red"],
    //             [0, 1, "white", "orange"],
    //             [1, 3, "white", "blue"],
    //             [3, 10000, "white", "green"],
    //         ],
    //     },
    // ];

    return (
        <div className="media">
            <h2>
                Alunos por Bairros
            </h2>
            <Chart
                chartType="Table"
                width="100%"
                version="current"

                data={chartDataBairro}
                options={options}
                // formatters={formatters}
                chartWrapperParams={{ view: { columns: [0, 1, 2] } }}
                chartPackages={["corechart", "controls"]}
                controls={[
                    {
                        controlEvents: [
                            {
                                eventName: "statechange",
                                callback: ({ chartWrapper, controlWrapper }) => {
                                    console.log("State changed to", controlWrapper?.getState());
                                },
                            },
                        ],
                        controlType: "CategoryFilter",
                        options: {
                            filterColumnIndex: 0,
                            ui: {
                                labelStacking: "vertical",
                                label: "Unidade",
                                allowTyping: false,
                                allowMultiple: true,
                            },
                        },
                    },
                    {
                        controlEvents: [
                            {
                                eventName: "statechange",
                                callback: ({ chartWrapper, controlWrapper }) => {
                                    console.log("State changed to", controlWrapper?.getState());
                                },
                            },
                        ],
                        controlType: "CategoryFilter",
                        options: {
                            filterColumnIndex: 1,
                            ui: {
                                labelStacking: "vertical",
                                label: "Bairro",
                                allowTyping: false,
                                allowMultiple: true,
                            },
                        },
                    },

                ]}
            />
        </div>
    );
};
export default Alunos_bairros;